module.exports = __webpack_public_path__ + "static/img/kuozhan.3a4a9756.png";